import { bubble, bubbleBorder, bubbleOutline } from './BubbleShape.sty.js';

/**
 * Bubble Shape Props
 * @internal
 */
export interface BubbleShapeProps {
  active?: boolean;
  color: string;
}

export const BubbleShape = ({ active = false, color }: BubbleShapeProps) => {
  return (
    <div className={bubbleOutline({ active })}>
      <div className={bubbleBorder} style={{ borderColor: color }}>
        <div className={bubble} style={{ backgroundColor: color }} />
      </div>
    </div>
  );
};

BubbleShape['displayName'] = 'BubbleShape';
